import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const PrivacyPolicy = lazy(() => import('../pages/PrivacyPolicy'));
const TermsOfService = lazy(() => import('../pages/TermsOfService'));
const Login = lazy(() => import('../pages/Login'));
const Register = lazy(() => import('../pages/Register'));
const ForgotPassword = lazy(() => import('../pages/ForgotPassword'));
const ProductDetail = lazy(() => import('../pages/ProductDetail'));
const ServiceDetail = lazy(() => import('../pages/ServiceDetail'));
const CategoryDetail = lazy(() => import('../pages/CategoryDetail'));
const Checkout = lazy(() => import('../pages/Checkout'));
const UserCenter = lazy(() => import('../pages/UserCenter'));
const OrderList = lazy(() => import('../pages/OrderList'));
const AddressList = lazy(() => import('../pages/AddressList'));
const Security = lazy(() => import('../pages/Security'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/terms-of-service',
    element: <TermsOfService />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/register',
    element: <Register />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />,
  },
  {
    path: '/product/:id',
    element: <ProductDetail />,
  },
  {
    path: '/service/:id',
    element: <ServiceDetail />,
  },
  {
    path: '/category/:id',
    element: <CategoryDetail />,
  },
  {
    path: '/checkout',
    element: <Checkout />,
  },
  {
    path: '/user/profile',
    element: <UserCenter />,
  },
  {
    path: '/user/orders',
    element: <OrderList />,
  },
  {
    path: '/user/addresses',
    element: <AddressList />,
  },
  {
    path: '/user/security',
    element: <Security />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;